import Section from './TermsSection'
import isEmpty from './TermsIsEmpty'

export default { isEmpty, Section }
